import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines, Reveal, Eyebrow } from "../components/motion";
import { ProductCard } from "../components/ProductCard";
import { useProducts } from "../hooks/useProducts";

export default function ScrubPage() {
  const { products } = useProducts();
  const scrubs = products.filter((p) => p.category === "scrub");

  return (
    <main data-testid="scrub-page" className="pb-20">
      <section className="bg-gradient-to-b from-lilac-soft/70 to-transparent py-14 sm:py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <Reveal>
            <Eyebrow className="justify-center">Scrub cuoio capelluto</Eyebrow>
          </Reveal>
          <MaskedLines
            as="h1"
            delay={0.1}
            lines={["Una cute pulita", "è il primo gesto per i tuoi capelli"]}
            className="mt-4 font-serif text-4xl sm:text-5xl text-plum tracking-tight leading-[1.12]"
          />
          <Reveal delay={0.4}>
            <p className="mt-6 text-base sm:text-lg text-plum/60 leading-relaxed max-w-2xl mx-auto">
              Ogni cuoio capelluto ha la sua esigenza. Scegli lo scrub pensato per il tuo:
              purificante per la cute grassa, delicato per quella normale o secca.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 mt-14">
        <div className="grid sm:grid-cols-2 gap-6">
          {scrubs.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 bg-plum rounded-[2.5rem] p-10 sm:p-14 text-center texture-grain relative overflow-hidden">
            <h2 className="font-serif text-2xl sm:text-3xl text-highlight tracking-tight">
              Non sai quale scrub scegliere?
            </h2>
            <p className="mt-4 text-white/70 text-base max-w-lg mx-auto">
              Rispondi a poche domande e ti guidiamo verso il prodotto più adatto al tuo cuoio capelluto.
            </p>
            <Link
              to="/quiz"
              data-testid="scrub-quiz-cta"
              className="inline-flex items-center gap-2 mt-8 px-8 py-4 rounded-full bg-lilac text-white font-bold text-sm uppercase tracking-[0.14em] hover:bg-lilac-dark active:scale-95 transition-all duration-300"
            >
              Inizia il percorso guidato <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
